import React from 'react';
import PropTypes from 'prop-types';

import Logo, {LOGO_TYPES, BRAND_TYPES as LOGO_BRANDS} from '@stubhub/react-logo';

import './index.scss';

/**
 * Renders a simple header component.
 *
 * @param {Object} props - The props object.
 * @param {Object} context - The context object containing the global registry.
 * @returns {JSX.Element} The rendered header component.
 */
const SimpleHeader = ({redirectTo}, {globalRegistry}) => {
  const useAltBrand =
    globalRegistry &&
    typeof globalRegistry.getFeatureValue === 'function' &&
    globalRegistry.getFeatureValue('common.useAltBrand');

  return (
    <div className="Simple__Header">
      <div className="Header__Content">
        <Logo
          type={LOGO_TYPES.MERCH}
          brand={useAltBrand ? LOGO_BRANDS.ALTERNATIVE : LOGO_BRANDS.DEFAULT}
          href={redirectTo}
        />
      </div>
    </div>
  );
};

SimpleHeader.contextTypes = {
  /** The global registry object */
  globalRegistry: PropTypes.object,
};

SimpleHeader.propTypes = {
  /** The URL to redirect to when the logo is clicked */
  redirectTo: PropTypes.string,
};

export default SimpleHeader;
